import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { c as cx } from './index-tZvMCc77.js';
import { B as Button } from './Button-DbVpPjA8-CRQ01IJx.js';
import { S as SvgClose } from './close-DZj38AEh.js';
import { S as SvgError, a as SvgWarning, b as SvgCheckCircle, c as SvgInfo } from './check_circle-DJhuiYqa.js';
import { I as Icon } from './Icon-BBWg60pO-Dja0R43O.js';
import { u as useLayoutPropsUtil } from './useLayoutPropsUtil-GT5myWCm-Cgn7OEq9.js';

import './Alert-Dgaqfx1H.css';const alert = "_alert_1i66z_3";
const content = "_content_1i66z_35";
const top = "_top_1i66z_43";
const success = "_success_1i66z_61";
const warning = "_warning_1i66z_67";
const danger = "_danger_1i66z_73";
const styles = {
	alert: alert,
	"close-container": "_close-container_1i66z_28",
	content: content,
	top: top,
	"title-container": "_title-container_1i66z_49",
	"status-icon": "_status-icon_1i66z_57",
	success: success,
	warning: warning,
	danger: danger,
	"close-button": "_close-button_1i66z_81"
};

const statusIconMap = {
  info: SvgInfo,
  success: SvgCheckCircle,
  warning: SvgWarning,
  danger: SvgError
};
const Alert = forwardRef((props, ref) => {
  const { layoutStyles, componentProps } = useLayoutPropsUtil(props);
  const {
    children,
    className,
    title,
    status = "info",
    style,
    onClose,
    ...rest
  } = componentProps;
  const alertCx = cx(styles["alert"], className, {
    [styles["success"]]: status === "success",
    [styles["warning"]]: status === "warning",
    [styles["danger"]]: status === "danger"
  });
  const styleCombined = {
    ...style,
    ...layoutStyles
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      "data-anv": "alert",
      role: "status",
      className: alertCx,
      style: styleCombined,
      ...rest,
      ref,
      children: [
        /* @__PURE__ */ jsxs("div", { className: styles["top"], children: [
          /* @__PURE__ */ jsxs("span", { className: styles["title-container"], children: [
            /* @__PURE__ */ jsx(
              Icon,
              {
                size: "large",
                className: styles["status-icon"],
                svg: statusIconMap[status ?? "info"]
              }
            ),
            title
          ] }),
          !!onClose && /* @__PURE__ */ jsx("span", { className: styles["close-container"], children: /* @__PURE__ */ jsx(
            Button,
            {
              icon: SvgClose,
              size: "small",
              appearance: "ghost",
              className: styles["close-button"],
              onClick: (e) => onClose(e),
              "aria-label": `Dismiss ${status} alert`
            }
          ) })
        ] }),
        children && /* @__PURE__ */ jsx("div", { className: styles["content"], children })
      ]
    }
  );
});
Alert.displayName = "Alert";

export { Alert as A };
//# sourceMappingURL=Alert-Dgaqfx1H-B6i-eGef.js.map
